function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ViewPostTemplate = require('./view-post.template');
var SaitoUser = require('./../../../../lib/saito/ui/saito-user/saito-user');
var ViewPost = /*#__PURE__*/function () {
  function ViewPost(app, mod, container) {
    var tx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, ViewPost);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.tx = tx;
  }
  return _createClass(ViewPost, [{
    key: "render",
    value: function render() {
      var _this = this;
      var tx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Clear this out
      this.authorPublicKey = null;

      // Update transaction if provided
      if (tx !== null) {
        this.tx = tx;
      }

      // Handle null transaction by creating a mock transaction
      if (!this.tx) {
        this.tx = this.createMockTransaction();
      }

      // ========================================================================
      // CANONICAL URL UPDATE: Update browser URL to reflect the post being viewed
      // ========================================================================
      if (this.tx && this.tx.signature) {
        this.authorPublicKey = this.tx.from && this.tx.from.length > 0 ? this.tx.from[0].publicKey || this.tx.from[0].address || '' : '';
        if (this.authorPublicKey) {
          var canonicalUrl = "/".concat(this.mod.slug, "/").concat(this.authorPublicKey, "/").concat(this.tx.signature);
          // Use pushState to update URL without reload (allows back button to work)
          window.history.pushState({
            view: 'stack_post',
            publicKey: this.authorPublicKey,
            signature: this.tx.signature
          }, null, canonicalUrl);
        }
      }
      var html = ViewPostTemplate(this.app, this.mod, this.tx);

      // Render into container
      if (typeof this.container === 'string') {
        var containerEl = document.querySelector(this.container);
        if (containerEl) {
          containerEl.innerHTML = html;
          // Don't reset opacity/transition here - let the transition handler manage it
        } else {
          console.error('ViewPost: Container not found:', this.container);
          return;
        }
      } else if (this.container) {
        this.container.innerHTML = html;
        // Don't reset opacity/transition here - let the transition handler manage it
      } else {
        console.error('ViewPost: Invalid container');
        return;
      }

      // Attach events after render
      setTimeout(function () {
        _this.attachEvents();
        _this.renderAuthorBlock();
      }, 25);
    }
  }, {
    key: "renderAuthorBlock",
    value: function renderAuthorBlock() {
      // Render SaitoUser component for author identity
      var authorContainer = document.querySelector('#stack-view-post-author-container');
      if (!authorContainer || !this.tx) return;

      // Get sender public key from transaction (canonical Saito field)

      if (!this.authorPublicKey) return;

      // Get publish date from transaction timestamp
      var timestamp = this.tx.timestamp || Date.now();
      var date = this.app.browser.formatDate ? this.app.browser.formatDate(timestamp) : null;
      var dateString = date ? "".concat(date.month, " ").concat(date.day, ", ").concat(date.year) : '';

      // Use SaitoUser component - notice parameter shows publish date as secondary line
      // Do NOT override SaitoUser CSS - use default styling
      var saitoUser = new SaitoUser(this.app, this.mod, '#stack-view-post-author-container', this.authorPublicKey, dateString,
      // Use notice parameter for publish date (renders as saito-userline)
      '' // fourthelem
      );
      saitoUser.render();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        // EDITOR icon (pencil) - only visible to post author, opens editor with post content
        var editorIcon = document.querySelector('#stack-view-post-build-on');
        if (editorIcon) {
          var currentUserPublicKey = this.mod.publicKey || '';
          if (this.authorPublicKey === currentUserPublicKey && this.authorPublicKey) {
            // Show icon for author
            editorIcon.classList.remove('is-hidden');
            editorIcon.addEventListener('click', function (e) {
              e.preventDefault();
              _this2.handleBuildOn();
            });
          } else {
            // Hide icon for non-authors
            editorIcon.classList.add('is-hidden');
          }
        }

        // Follow
        var followIcon = document.querySelector('#stack-view-post-subscribe');
        if (followIcon) {
          if (this.authorPublicKey !== this.mod.publicKey) {
            if (!this.mod.isSubscribed(this.authorPublicKey)) {
              followIcon.classList.remove('is-hidden');
              followIcon.onclick = function (e) {
                e.preventDefault();
                var added = _this2.mod.addSubscription(_this2.authorPublicKey);
                if (added) {
                  followIcon.classList.add('is-hidden');
                  siteMessage('Subscribed!', 2000);
                } else {
                  console.info(' ! Subscribe failed...', _this2.authorPublicKey, _this2.app.options.stack.subscriptions);
                }
              };
            }
          }
        }

        // Share icon - generic share
        var shareBtn = document.querySelector('#stack-view-post-share');
        if (shareBtn) {
          shareBtn.addEventListener('click', /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
              var longUrl, msg, _msg$data, url, _msg$data2, _t;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    e.preventDefault();
                    if (!(!_this2.tx || !_this2.authorPublicKey)) {
                      _context.n = 1;
                      break;
                    }
                    return _context.a(2);
                  case 1:
                    longUrl = window.location.href;
                    if (_this2.authorPublicKey && _this2.tx.signature) {
                      longUrl = "/".concat(_this2.mod.slug, "/").concat(_this2.authorPublicKey, "/").concat(_this2.tx.signature);
                      if (!longUrl.startsWith('http')) {
                        longUrl = window.location.origin + longUrl;
                      }
                    }
                    msg = _this2.tx.returnMessage();
                    _context.p = 2;
                    _context.n = 3;
                    return _this2.mod.createShortLink(longUrl);
                  case 3:
                    url = _context.v;
                    _this2.app.browser.handleShare({
                      title: (msg === null || msg === void 0 || (_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.title) || 'Stack Post',
                      url: url
                    });
                    _context.n = 5;
                    break;
                  case 4:
                    _context.p = 4;
                    _t = _context.v;
                    console.error('Stack post share failed:', _t);
                    _this2.app.browser.handleShare({
                      title: (msg === null || msg === void 0 || (_msg$data2 = msg.data) === null || _msg$data2 === void 0 ? void 0 : _msg$data2.title) || 'Stack Post',
                      url: longUrl
                    });
                  case 5:
                    return _context.a(2);
                }
              }, _callee, null, [[2, 4]]);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        }
      } catch (err) {
        console.error('ViewPost attachEvents error:', err);
      }
    }
  }, {
    key: "handleBuildOn",
    value: function handleBuildOn() {
      var _this3 = this;
      if (!this.tx || !this.mod || !this.mod.create_post_ui) return;

      // Extract post data from transaction
      var msg = this.tx.returnMessage();
      var data = msg && msg.data ? msg.data : {};
      var title = data.title || '';
      var content = data.content || data.text || '';

      // ========================================================================
      // INVARIANT 4: Unmount before navigating to editor (navigation path: viewer → editor)
      // ========================================================================
      if (typeof this.mod.create_post_ui.onEditorUnmount === 'function') {
        this.mod.create_post_ui.onEditorUnmount();
      }

      // ========================================================================
      // INVARIANT 2: Editor requires explicit intent - use "edit" mode for building on existing post
      // ========================================================================
      // Note: The editor will render with default "new" intent, then we load the post content
      // This is acceptable as "edit" mode is essentially "new" mode with pre-filled content
      // Render the editor (will use default "new" intent from render())
      this.mod.create_post_ui.render();

      // Load post content into editor after a short delay to ensure DOM is ready
      setTimeout(function () {
        var _require = require('../post-document'),
          parseMarkdownToDocument = _require.parseMarkdownToDocument,
          renderDocument = _require.renderDocument;

        // Set title
        var titleInput = document.querySelector('#stack-post-title-input');
        if (titleInput) {
          titleInput.value = title;
        }

        // Load content into editor
        var editor = document.querySelector('#stack-post-body-editor');
        if (editor) {
          if (content.trim()) {
            // ----------------------------------------------------
            // RESOLVE stack:image:* REFERENCES BEFORE EDIT RENDER
            // ----------------------------------------------------
            var resolvedContent = content;
            if (Array.isArray(data.images) && data.images.length > 0) {
              resolvedContent = resolvedContent.replace(/!\[([^\]]*)\]\(stack:image:([^)]+)\)/g, function (match, alt, imageId) {
                var image = data.images.find(function (img) {
                  return img.id === imageId;
                });
                if (!image) return match;
                var src = "data:".concat(image.mime, ";base64,").concat(image.data);
                return "![".concat(alt || '', "](").concat(src, ")");
              });
            }

            // Parse markdown content to document structure
            var tempDocument = parseMarkdownToDocument(resolvedContent);
            renderDocument(tempDocument, editor, {
              contentEditable: true
            });

            // ----------------------------------------------------
            // RESTORE IMAGE REGISTRY + STAMP stackImageId (EDIT MODE)
            // ----------------------------------------------------
            if (Array.isArray(data.images)) {
              // Restore editor image registry
              _this3.mod.create_post_ui.images = _toConsumableArray(data.images);

              // ----------------------------------------------------
              // NORMALIZE IMAGES INTO REAL IMAGE BLOCKS
              // ----------------------------------------------------
              var imgNodes = Array.from(editor.querySelectorAll('img'));
              imgNodes.forEach(function (img, i) {
                var parent = img.closest('[data-block-type="image"]');
                if (parent) return;
                var figure = document.createElement('figure');
                var blockId = "img_block_".concat(Date.now(), "_").concat(i);
                figure.setAttribute('data-block-id', blockId);
                figure.setAttribute('data-block-type', 'image');
                figure.className = 'image-block';
                figure.contentEditable = false;
                img.replaceWith(figure);
                figure.appendChild(img);
              });

              // ----------------------------------------------------
              // RE-STAMP stackImageId AFTER NORMALIZATION
              // ----------------------------------------------------
              for (var i = 0; i < imgNodes.length; i++) {
                if (data.images[i]) {
                  imgNodes[i].dataset.stackImageId = data.images[i].id;
                }
              }
            }
          } else {
            // Empty content - render empty document
            var _require2 = require('../post-document'),
              generateBlockId = _require2.generateBlockId;
            var _tempDocument = {
              blocks: [{
                type: 'paragraph',
                id: generateBlockId(0),
                text: ''
              }]
            };
            renderDocument(_tempDocument, editor, {
              contentEditable: true
            });
          }
        }

        // Load featured image if present
        if (data.image && _this3.mod.create_post_ui) {
          _this3.mod.create_post_ui.featuredImage = data.image;
          setTimeout(function () {
            if (_this3.mod.create_post_ui && typeof _this3.mod.create_post_ui.updateFeaturedImageDisplay === 'function') {
              _this3.mod.create_post_ui.updateFeaturedImageDisplay();
            }
          }, 50);
        }

        // PART 2 — DETECTING PUBLISHED POSTS: Set parent_id for editing
        // Post loaded from transaction (view-post) is a published post
        // Determine root signature: if post has parent_id, use it; otherwise use post's own signature
        var parent_id = data.parent_id || null;
        if (_this3.mod.create_post_ui) {
          if (parent_id) {
            // This is a revision - root is the parent_id
            _this3.mod.create_post_ui.parent_id = parent_id;
          } else {
            // This is a root post - root is the post's own signature
            _this3.mod.create_post_ui.parent_id = _this3.tx.signature;
          }
          if (typeof _this3.mod.create_post_ui.updatePlaceholderVisibility === 'function') {
            _this3.mod.create_post_ui.updatePlaceholderVisibility();
          }
          if (typeof _this3.mod.create_post_ui.updatePublishTriggerVisibility === 'function') {
            _this3.mod.create_post_ui.updatePublishTriggerVisibility();
          }
          if (typeof _this3.mod.create_post_ui.updatePublishTriggerState === 'function') {
            _this3.mod.create_post_ui.updatePublishTriggerState();
          }
        }
      }, 100);
    }

    /**
     * Creates a mock transaction for development/testing when tx is null.
     * This is a temporary development bridge and should be replaced with real transactions.
     */
  }, {
    key: "createMockTransaction",
    value: function createMockTransaction() {
      // Create a mock transaction object that matches the Stack transaction structure
      var mockTx = {
        from: [{
          publicKey: 'mock-author-key-1234567890abcdef'
        }],
        timestamp: Date.now() - 86400000 * 3,
        // 3 days ago
        signature: 'mock-signature-1234567890',
        returnMessage: function returnMessage() {
          return {
            module: 'Stack',
            request: 'create stack post request',
            data: {
              type: 'stack_post',
              title: 'On Shared Dreaming',
              subtitle: 'Exploring the architecture of collective consciousness',
              summary: 'What happens when we build worlds together, not just in our minds, but in spaces we can enter together? The question of shared dreaming touches on something fundamental about how we construct reality and trust one another within it.',
              text: "# On Shared Dreaming\n\nThe idea of shared dreaming has haunted human imagination for as long as we have told stories. What happens when we build worlds together, not just in our minds, but in spaces we can enter together? The question touches on something fundamental about how we construct reality and trust one another within it.\n\n## The Architecture of Collective Consciousness\n\nWhen we dream alone, the rules are simple: everything we encounter is a product of our own mind. The physics, the logic, the people\u2014all of it exists because we believe it does. But what if someone else could enter that space? What if the dream had to accommodate not just one consciousness, but two, or many?\n\nThe first challenge is coordination. In a private dream, you can change the rules on a whim. A door that was locked can suddenly be open because you willed it. But in a shared space, such changes require consensus, or at least acknowledgment. The shared dream becomes a negotiation, a collaborative construction where each participant brings their own expectations and limitations.\n\nThis negotiation is not just about what is possible, but about what is real. In your own dream, you know\u2014or at least believe\u2014that everything you see is a projection. But when another person enters, their presence introduces a fundamental uncertainty: are they real, or are they another projection? The question of authenticity becomes central, and trust becomes the currency of the shared space.\n\n## Trust and Coordination Inside a Dream\n\nTrust in a shared dream operates differently than trust in waking life. In the physical world, we have external referents\u2014we can touch, measure, verify. But in a dream, verification is circular. If I ask you to prove you're real, and you respond, how do I know your response isn't just my mind creating what I expect to hear?\n\nThe answer, perhaps, is that trust in a shared dream is not about verification, but about surrender. To enter someone else's dream is to accept, at least provisionally, that their reality is as valid as your own. It is to agree to play by rules you did not create, to see things you did not imagine, to experience perspectives that are genuinely other.\n\nThis surrender is not passive. It requires active participation in the construction of the shared space. You must contribute your own elements, your own rules, your own understanding. The dream becomes a collaborative work, constantly being rewritten by all participants.\n\n## The Difference Between Private and Collective Experience\n\nA private dream is a monologue. A shared dream is a dialogue, or perhaps a polyphonic composition where multiple voices speak simultaneously, sometimes in harmony, sometimes in tension.\n\nIn a private dream, you are both the author and the audience. You know the plot because you wrote it, even if you don't remember writing it. But in a shared dream, you are only one of the authors, and you are constantly surprised by what the others create. The experience becomes genuinely collaborative, genuinely unpredictable.\n\nThis unpredictability is both the risk and the reward. In a private dream, you can control everything, but you can also be trapped by your own limitations. In a shared dream, you lose control, but you gain access to perspectives and possibilities you could never have imagined alone.\n\n## The Boundaries of Shared Space\n\nThe question of boundaries becomes crucial. Where does one person's dream end and another's begin? If we are truly sharing a space, then the boundaries must be permeable, or perhaps non-existent. But if there are no boundaries, how do we maintain our individual identity? How do we know where we end and the other begins?\n\nPerhaps the answer is that in a truly shared dream, identity itself becomes fluid. You are not just yourself, but also part of the collective construction. Your thoughts influence the space, and the space influences your thoughts. The distinction between self and other, between internal and external, begins to blur.\n\nThis blurring is not necessarily a loss. It can be an expansion, a way of experiencing consciousness that transcends individual boundaries. But it also requires a kind of courage\u2014the willingness to let go of the certainty that comes with being the sole author of your reality.\n\n## The Ethics of Shared Dreaming\n\nIf we can truly share dreams, then we must consider the ethics of such sharing. What are the responsibilities of the dream architect? What are the rights of the dream participant? Can someone be harmed in a shared dream? Can they be healed?\n\nThese questions are not just theoretical. They touch on fundamental issues of consent, agency, and the nature of experience itself. If a shared dream feels real, does that make it real? And if it is real, what obligations do we have to those who share it with us?\n\nThe answer may be that shared dreaming, like any form of shared experience, requires mutual respect and care. We must enter each other's spaces with intention, with awareness of the power we have to shape the experience, and with respect for the autonomy of others.\n\n## Conclusion: The Promise of Shared Spaces\n\nShared dreaming, whether literal or metaphorical, represents a profound possibility: that we can construct realities together, that we can experience consciousness not just individually but collectively. This possibility challenges our assumptions about the boundaries of self and other, about what is real and what is imagined.\n\nIn the end, perhaps the question is not whether shared dreaming is possible, but whether we are willing to take the risk of entering spaces we did not create, of trusting others with the architecture of our experience, of surrendering control in exchange for the possibility of genuine collaboration.\n\nThe shared dream, then, becomes a metaphor for all forms of collective construction\u2014for art, for community, for the ways we build worlds together in waking life. And in that sense, we are all already shared dreamers, architects of spaces we enter together, constantly negotiating the rules, the boundaries, and the meaning of what we create.\n\nThe idea of shared dreaming has haunted human imagination for as long as we have told stories. What happens when we build worlds together, not just in our minds, but in spaces we can enter together? The question touches on something fundamental about how we construct reality and trust one another within it.\n\n## The Architecture of Collective Consciousness\n\nWhen we dream alone, the rules are simple: everything we encounter is a product of our own mind. The physics, the logic, the people\u2014all of it exists because we believe it does. But what if someone else could enter that space? What if the dream had to accommodate not just one consciousness, but two, or many?\n\nThe first challenge is coordination. In a private dream, you can change the rules on a whim. A door that was locked can suddenly be open because you willed it. But in a shared space, such changes require consensus, or at least acknowledgment. The shared dream becomes a negotiation, a collaborative construction where each participant brings their own expectations and limitations.\n\nThis negotiation is not just about what is possible, but about what is real. In your own dream, you know\u2014or at least believe\u2014that everything you see is a projection. But when another person enters, their presence introduces a fundamental uncertainty: are they real, or are they another projection? The question of authenticity becomes central, and trust becomes the currency of the shared space.\n\n## Trust and Coordination Inside a Dream\n\nTrust in a shared dream operates differently than trust in waking life. In the physical world, we have external referents\u2014we can touch, measure, verify. But in a dream, verification is circular. If I ask you to prove you're real, and you respond, how do I know your response isn't just my mind creating what I expect to hear?\n\nThe answer, perhaps, is that trust in a shared dream is not about verification, but about surrender. To enter someone else's dream is to accept, at least provisionally, that their reality is as valid as your own. It is to agree to play by rules you did not create, to see things you did not imagine, to experience perspectives that are genuinely other.\n\nThis surrender is not passive. It requires active participation in the construction of the shared space. You must contribute your own elements, your own rules, your own understanding. The dream becomes a collaborative work, constantly being rewritten by all participants.\n\n## The Difference Between Private and Collective Experience\n\nA private dream is a monologue. A shared dream is a dialogue, or perhaps a polyphonic composition where multiple voices speak simultaneously, sometimes in harmony, sometimes in tension.\n\nIn a private dream, you are both the author and the audience. You know the plot because you wrote it, even if you don't remember writing it. But in a shared dream, you are only one of the authors, and you are constantly surprised by what the others create. The experience becomes genuinely collaborative, genuinely unpredictable.\n\nThis unpredictability is both the risk and the reward. In a private dream, you can control everything, but you can also be trapped by your own limitations. In a shared dream, you lose control, but you gain access to perspectives and possibilities you could never have imagined alone.\n\n## The Boundaries of Shared Space\n\nThe question of boundaries becomes crucial. Where does one person's dream end and another's begin? If we are truly sharing a space, then the boundaries must be permeable, or perhaps non-existent. But if there are no boundaries, how do we maintain our individual identity? How do we know where we end and the other begins?\n\nPerhaps the answer is that in a truly shared dream, identity itself becomes fluid. You are not just yourself, but also part of the collective construction. Your thoughts influence the space, and the space influences your thoughts. The distinction between self and other, between internal and external, begins to blur.\n\nThis blurring is not necessarily a loss. It can be an expansion, a way of experiencing consciousness that transcends individual boundaries. But it also requires a kind of courage\u2014the willingness to let go of the certainty that comes with being the sole author of your reality.\n\n## The Ethics of Shared Dreaming\n\nIf we can truly share dreams, then we must consider the ethics of such sharing. What are the responsibilities of the dream architect? What are the rights of the dream participant? Can someone be harmed in a shared dream? Can they be healed?\n\nThese questions are not just theoretical. They touch on fundamental issues of consent, agency, and the nature of experience itself. If a shared dream feels real, does that make it real? And if it is real, what obligations do we have to those who share it with us?\n\nThe answer may be that shared dreaming, like any form of shared experience, requires mutual respect and care. We must enter each other's spaces with intention, with awareness of the power we have to shape the experience, and with respect for the autonomy of others.\n\n## Conclusion: The Promise of Shared Spaces\n\nShared dreaming, whether literal or metaphorical, represents a profound possibility: that we can construct realities together, that we can experience consciousness not just individually but collectively. This possibility challenges our assumptions about the boundaries of self and other, about what is real and what is imagined.\n\nIn the end, perhaps the question is not whether shared dreaming is possible, but whether we are willing to take the risk of entering spaces we did not create, of trusting others with the architecture of our experience, of surrendering control in exchange for the possibility of genuine collaboration.\n\nThe shared dream, then, becomes a metaphor for all forms of collective construction\u2014for art, for community, for the ways we build worlds together in waking life. And in that sense, we are all already shared dreamers, architects of spaces we enter together, constantly negotiating the rules, the boundaries, and the meaning of what we create.",
              image: null,
              imageUrl: '/saito/img/dreamscape.png',
              images: [],
              url: window.location.href + '#post/mock-shared-dreaming',
              tags: [],
              timestamp: Date.now() - 86400000 * 3,
              subscriptionTier: 'free',
              excerpt: 'What happens when we build worlds together, not just in our minds, but in spaces we can enter together? The question of shared dreaming touches on something fundamental about how we construct reality and trust one another within it.'
            }
          };
        }
      };
      return mockTx;
    }
  }]);
}();
module.exports = ViewPost;